import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs/index';
import { CommonUiNavConfig } from '../types/common-ui-nav-config';

@Injectable({
  providedIn: 'root'
})
export class MxAccessResolver implements Resolve<CommonUiNavConfig> {
  constructor() {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<CommonUiNavConfig> {
    return of(new CommonUiNavConfig(false, true));
  }
}
